export enum TranslationKey {
	valid = 'valid',
	hq = 'hq',
	approved = 'approved',
	validExist = 'valid-exist',
	purchaseType = 'purchase-type',
	payType = 'payType',
	state = 'state',
	scope = 'scope',
	reportsType = 'reports-type',
	key = 'key',
	collectionSource = 'collectionSource',
	purchaseBill = 'purchaseBill',
	accountSource = 'accountSource',
	draweeType = 'draweeType',
	pricingType = 'pricingType',
	umId = 'umId',
	shipmentStatus = 'shipmentStatus',
	tracingStatus = 'tracingStatus',
	einvoiceDocumentType = 'einvoiceDocumentType',
	einvoiceSendStatus = 'einvoiceSendStatus',
	einvoiceDeliveryStatus = 'einvoiceDeliveryStatus',
	einvoiceMainType = 'einvoiceMainType',
	saleOrderMaster = 'saleOrderMaster',
	shippingStatus = 'shippingStatus',
	shippingDetailType = 'shippingDetailType',
	accountTransactionType = 'accountTransactionType',
	deliveryDateBase = 'deliveryDateBase',
	allowDetailType = 'allowDetailType',
	deliveryDateAssign = 'deliveryDateAssign',
}
